import React from "react";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import "./Dropdown.css";

// http://confluence.edisoft.com:8090/x/ojqWB
const Dropdown = ({
  label,
  value,
  options,
  onChange,
  width,
  multiple = false,
  hideNoneOption = true,
  actionLabel,
  actionOnClick,
  disabled,
}) => {
  return (
    <FormControl style={{ width: width }}>
      <InputLabel>{label}</InputLabel>
      <Select
        disabled={disabled}
        onChange={onChange}
        value={value ? value : ""}
        multiple={multiple}
        MenuProps={{ disablePortal: true }} // For Dropdown options rendering will be under the DOM of parent component.
        // Ref: https://stackoverflow.com/questions/61376276/setting-z-index-of-autocomplete-dropdown-and-using-getoptionselected
      >
        {!hideNoneOption && !multiple && (
          <MenuItem value={""}>
            <em>None</em>
          </MenuItem>
        )}
        {options &&
          options.map((option) => (
            <MenuItem key={option.key} value={option.key}>
              {option.label}
            </MenuItem>
          ))}
        {(actionLabel ?? false) && (
          <MenuItem
            className="dropdown-action"
            value="dropdown-action"
            onClick={actionOnClick}
          >
            {actionLabel}
          </MenuItem>
        )}
      </Select>
    </FormControl>
  );
};
export default Dropdown;
